import { NOTIFICATION_REGISTRY } from './notificationText';

export type NotificationType = 'SUCCESS' | 'ERROR' | 'INFO' | 'WARNING';
export type NotificationRole = 'ADMIN' | 'USER';

export interface NotificationUser {
  id: string;
  name: string;
  email: string;
}

export interface NotificationDetails {
  processed_count?: number;
  total_count?: number;
  percentage?: number;
  error_count?: number;
  technical_error_count?: number;
  errors_download_url?: string;
  [key: string]: unknown;
}

export interface NotificationContent {
  title: string;
  details: NotificationDetails;
}

export interface UserNotification {
  id: string;
  notification_id: string;
  is_read: boolean;
  type: NotificationType;
  timestamp: string;
  user?: NotificationUser;
  company_id: number;
  role: NotificationRole;
  content: NotificationContent;
}

// ── Configuración de visualización ──────────────────────────────────────

/** Botón de acción de una notificación */
export interface NotificationAction {
  /** Texto del botón */
  label: string;
  /** Icono Material Symbols del botón */
  icon?: string;
  /**
   * Campo de `NotificationDetails` que contiene la URL de descarga.
   * Si se define, el botón solo aparece cuando dicho campo tiene valor
   * y al pulsarlo se inicia la descarga.
   */
  downloadUrlField?: string;
  /** Construye el nombre del archivo descargado */
  buildFileName?: (
    notification: UserNotification,
    companyName: string
  ) => string;
}

/** Configuración de visualización de un tipo de notificación */
export interface NotificationConfig {
  /** Texto descriptivo */
  text: string | ((details: NotificationDetails) => string);
  /** Icono Material Symbols */
  icon: string;
  /** Mostrar barra de progreso (usa percentage / processed_count / total_count) */
  showProgress?: boolean;
  /** Mostrar texto de progreso (ej: "20 de 75") */
  showProgressText?: boolean;
  /** Botón de acción opcional */
  action?: NotificationAction;
  /** Líneas de resumen entre el texto principal y las acciones */
  summaryLines?: (details: NotificationDetails) => string[];
}

const FALLBACK_CONFIG: NotificationConfig = {
  text: 'Notificación sin configurar',
  icon: 'info',
};

/** Devuelve la configuración de visualización para una notificación */
export function getNotificationConfig(
  notification: UserNotification
): NotificationConfig {
  return NOTIFICATION_REGISTRY[notification.content.title] ?? FALLBACK_CONFIG;
}
